// extracted by mini-css-extract-plugin
export default {"presentLabel":"ProfessionalExperienceForm_presentLabel__AB3kU"};